const seat = {
  appConfig: {
    brandName: 'seat',
    language: 'de-DE',
    isCarTypeSelectionEnabled: true
  }
};

export default seat;
